module.exports = __webpack_public_path__ + "img/ZB6109_1.0fef114e.jpg";